import { useQuery } from '@tanstack/react-query';
import { API, graphqlOperation } from 'aws-amplify';
import getUserAvatar from '../common/utils/getUserAvatar';
import getSentenceInitials from '../common/utils/getSentenceInitials';

const searchTeamsQuery = `
  query SearchTeams($orgID: ID!, $searchString: String!, $nextToken: String) {
    searchCircles(
      filter: {
        name: { wildcard: $searchString }
        orgID: { eq: $orgID }
        isDeleted: { eq: false }
      }
      limit: 750
      nextToken: $nextToken
      sort: { direction: asc, field: name }
    ) {
      items {
        id
        name
        imageName
        imageType
        isActive
        status
        levelID
      }
      nextToken
    }
  }
`;

const fetchTeams = async (orgID: string, searchString: string) => {
  const teams: any[] = [];
  let nextToken: string | null = null;

  do {
    const res: any = await API.graphql(
      graphqlOperation(searchTeamsQuery, {
        orgID,
        searchString: searchString || '*',
        nextToken,
      })
    );
    teams.push(...res.data.searchCircles.items);
    nextToken = res.data.searchCircles.nextToken;
  } while (nextToken);

  for (const team of teams) {
    team.avatar = await getUserAvatar(team.imageName);
    team.initials = getSentenceInitials(team.name);
  }

  return teams;
};

export default function useListTeams(searchString = '*') {
  const orgID = (global as any).me?.orgID;

  const { data, isLoading, error } = useQuery({
    queryKey: ['listTeams', orgID, searchString],
    queryFn: () => fetchTeams(orgID, searchString),
    enabled: !!orgID,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { data: data ?? [], isLoading, error };
}
